import type { FaireProductEntity } from "../../entity_types/product";

export const p_46qef7w7q8: FaireProductEntity = {
  token: "p_46qef7w7q8",
  type: "product",
  name: "Spark Organics Variety Pack 6ct",
  brandToken: "b_55apzekrkm",
  brandName: "Spark Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/1c5a577703ee590ba0a0a98fe17da6837da242939c5799a2f4f1f71470368b3e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bfd37a39485bfb0f29b60dbb3cf58ec29efa0b3b21c8862a4e74ebb4fd885b92.png",
    "https://cdn.faire.com/fastly/7dfb2745d2d1f92a756e080a6bc3b37bdc4cb90cb513f5920d7b73cb1d07f775.png",
    "https://cdn.faire.com/fastly/9fcb361bce4f9cc85c000a5985c73c10a6ac7cb16b0c93dce7280e4a19000ed9.jpeg",
    "https://cdn.faire.com/fastly/d0ecbee75283830e5cf594279b1578410ad0d06154666554c832616c9bd04b8f.jpeg",
    "https://cdn.faire.com/fastly/ea8f1279a8660dd7000cfb1cb969e433c70a6d788cab20882a3916381dc61dd5.png",
    "https://cdn.faire.com/fastly/223430638f29483828a683f19cdf0f3fd738dff26c548473a746216f0582625b.jpeg",
    "https://cdn.faire.com/fastly/cd295e0a218d5525580691bd4c027edd8320fa6f4c7a390975b45fa564cdb5d6.jpeg",
  ],
  priceDollars: 20.74,
  description:
    "New to our fruit chews? We've got a variety pack for you!\n\nThe 6ct variety pack contains two pouches each of our Superfruit Blend, Classic Blend and Tropical Blend pouches.\n\nAll our products are USDA Organic Certified, Non-GMO Project Verified, made with real fruit and contain the equivalent of 1/2 a serving of fruit per pouch.\n\nClassic Blend pouches: Strawberry, Banana and Peach flavor chews\n\nSuperfruit Blend pouches: Raspberry, Blueberry and Pomegranate flavor chews\n\nTropical Blend pouches: Pineapple, Banana and Mango flavor chews",
  tags: [],
  msrpDollars: 41.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:44.846Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
